import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AllClients from './pages/AllClients';
import AllReservate from './pages/AllReservate';
import AllReservateEnd from './pages/AllReservateEnd';
import PanelClients from './pages/PanelClients';
import Historial from './pages/Historial';
import Login from './pages/Login';

// Componente que verifica si el usuario está autenticado
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');

  // Si no hay token, redirige al login
  if (!token) {
    return <Navigate to="/iniciar-sesion" replace />;
  }

  return children;
}

// Componente que verifica si el usuario ya está autenticado
function PublicRoute({ children }) {
  const token = localStorage.getItem('token');

  // Si hay token, redirige al panel principal
  if (token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/* Ruta de inicio de sesión */}
          <Route path="/iniciar-sesion" element={<PublicRoute><Login /></PublicRoute>} />

          {/* Rutas protegidas */}
          <Route path="/" element={<ProtectedRoute><PanelClients /></ProtectedRoute>}>
            <Route index element={<AllClients />} />
            <Route path="clientes" element={<AllClients />} />
            <Route path="turnos" element={<AllReservate />} />
            <Route path="turnos-finalizados" element={<AllReservateEnd />} />
            <Route path="historial" element={<Historial />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
